"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Configuration =
/*#__PURE__*/
function () {
  function Configuration(token) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Configuration);

    var config = options.notifications || {};
    var region = config.region || options.region || 'us1';
    var defaultUrl = "https://ers.".concat(region, ".twilio.com/v1/registrations");
    this.registrarUrl = config.ersUrl || defaultUrl;
    this._token = token;
  }

  _createClass(Configuration, [{
    key: "updateToken",
    value: function updateToken(token) {
      this._token = token;
    }
  }, {
    key: "token",
    get: function get() {
      return this._token;
    }
  }]);

  return Configuration;
}();

exports.Configuration = Configuration;